export function scrollToElement(anchor: HTMLElement | null) {
  let endLocation = 0;
  if (anchor) {
    endLocation = getOffsetTop(anchor, 52, 10);
  }

  let startLocation = window.pageYOffset;
  let distance = endLocation - startLocation;
  let documentHeight = Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight,
  );
  let timeLapsed = 0;
  let start: number | null;
  let percentage: number;
  let position: number;
  let animationHandle: number;

  // tslint:disable-next-line:variable-name
  let stopAnimateScroll = (_position: number, _endLocation: number) => {
    let currentLocation = window.pageYOffset;

    if (
      _position === _endLocation ||
      currentLocation === _endLocation ||
      (startLocation < _endLocation && window.innerHeight + currentLocation) >= documentHeight
    ) {
      window.cancelAnimationFrame(animationHandle);

      start = null;

      return true;
    }

    return false;
  };

  let loopAnimateScroll = (timestamp: number) => {
    if (!start) {
      start = timestamp;
    }

    timeLapsed += timestamp - start;
    percentage = timeLapsed / 250;
    percentage = percentage > 1 ? 1 : percentage;
    position = startLocation + distance * (percentage * percentage);

    window.scrollTo(0, Math.floor(position));

    if (!stopAnimateScroll(position, endLocation)) {
      animationHandle = window.requestAnimationFrame(loopAnimateScroll);
      start = timestamp;
    }
  };

  animationHandle = window.requestAnimationFrame(loopAnimateScroll);
}

export function getOffsetTop(anchor: HTMLElement, headerHeight: number, offset: number) {
  let innerAnchor = anchor;
  let location = 0;

  if (innerAnchor.offsetParent) {
    do {
      location += innerAnchor.offsetTop;
      innerAnchor = innerAnchor.offsetParent as HTMLElement;
    } while (innerAnchor);
  }

  return Math.max(location - headerHeight - offset, 0);
}
